module.exports = __webpack_public_path__ + "static/img/image1.717cd1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/image1.jpg
// module id = tkvp
// module chunks = 3